import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  AddCustomerResponse,
  CustomerCommonResponse,
  Customer,
  CustomerResponse,
  CustomerType,
  AddCustomerTypeResponse,
  Type,
} from '@core/interface/customer';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private http: HttpClient) {}

  getCustomers(data?: PagePayload) {
    const filter = { ...data };
    if (typeof filter?.customer_type !== 'undefined') {
      filter.type = filter.customer_type;
    }
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<CustomerResponse>(environment.endPoints.customerList, {
      params: httpParams,
    });
  }
  addCustomer(data: Customer) {
    return this.http.post<AddCustomerResponse>(
      environment.endPoints.customerAddEdit,
      data
    );
  }
  deleteCustomer(id: number) {
    return this.http.get<CustomerCommonResponse>(
      environment.endPoints.customerDelete(id)
    );
  }

  getCustomerType() {
    return this.http.get<CustomerType>(environment.endPoints.customerType);
  }
  addCustomerType(data: Type) {
    return this.http.post<AddCustomerTypeResponse>(
      environment.endPoints.customerAddTypeEdit,
      data
    );
  }
  deleteCustomerType(id: number) {
    return this.http.get<CustomerCommonResponse>(
      environment.endPoints.customerTypeDelete(id)
    );
  }

  getCustomerJobNumbers(data: {
    customer_id: number | string;
    page?: number;
    limit?: number;
    search?: string;
  }) {
    let httpParams = new HttpParams()
      .set('customer_id', `${data.customer_id}`)
      .set('page', `${data.page ?? 1}`)
      .set('limit', `${data.limit ?? 10}`);

    if (data.search) {
      httpParams = httpParams.set('search', data.search);
    }

    return this.http.get<any>(environment.endPoints.customerJobNumberList, {
      params: httpParams,
    });
  }

  addEditCustomerJobNumber(data: any) {
    return this.http.post<any>(environment.endPoints.customerJobNumberStore, data);
  }

  deleteCustomerJobNumber(id: number) {
    return this.http.get<any>(environment.endPoints.customerJobNumberDelete(id));
  }
}
